/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  actionDrawerStore: TypeActionDrawerStore,
  response: Object,
};

@translate()
@inject('actionDrawerStore')
@observer
export default class RequestAssetOwnershipSuccess extends React.Component<*> {
  render(): React.Fragment {
    const { t, actionDrawerStore, response }: TypeProps = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div className={styles['success-details']}>
            <h3>{t('general:assets.messages.ownership_request')}</h3>
            <p>{t('general:assets.messages.ownership_request_receipt')}</p>
            <p>{t('general:assets.messages.ownership_request_granted')}</p>
            <ul>
              <li>
                <b>{t('general:asset')}:</b>
              </li>
              <li>{`${response.asset_number}, ${response.manufacturer}, ${response.model}`}</li>
            </ul>
          </div>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
